// Historique local des lectures du pré-diagnostic.
//
// Sert de filet : même lorsque l'enregistrement serveur échoue, l'utilisateur
// ne perd pas son indice et peut comparer ses lectures successives.
// Ces données restent sur l'appareil et ne sont jamais envoyées ailleurs.
const KEY = "docthair_readings";
const MAX = 24;

const read = () => {
  try {
    const raw = window.localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const listReadings = () => read();

export const lastReading = () => read()[0] || null;

// `synced` indique si le serveur a bien accusé réception de la lecture.
export const saveReading = ({ answers, score, locale, synced = false }) => {
  try {
    const entry = { at: new Date().toISOString(), answers, score, locale, synced };
    const next = [entry, ...read()].slice(0, MAX);
    window.localStorage.setItem(KEY, JSON.stringify(next));
    return entry;
  } catch {
    // Stockage indisponible (navigation privée, quota) : la lecture reste
    // affichée à l'écran, elle n'est simplement pas conservée.
    return null;
  }
};
